<template>
  <div>
    <FormSection>
      <SiteSelect :disabled="editMode" v-model="order.site_uuid" :companyUuid="order.company_uuid" required />
      <ZoneSelect
        v-model="order.origin_zone_uuid"
        :name="$t('orderForm.originZone')"
        :siteUuid="order.site_uuid"
        :disabled="!order.site_uuid || order.status != 'open'"
        required
      />
      <ZoneSelect
        v-model="order.target_zone_uuid"
        :name="$t('orderForm.targetZone')"
        :siteUuid="order.site_uuid"
        :disabled="!order.site_uuid || order.status != 'open'"
        required
      />
    </FormSection>

    <FormSection>
      <ContainerSelect
        v-model="order.full_container_uuid"
        :companyUuid="order.company_uuid"
        :name="$t('orders.fullContainer')"
        :disabled="!order.site_uuid || order.status != 'open'"
        required
        :selectedContainerName="order.full_container && order.full_container.name"
        :onlyAvailableForOrders="true"
      />
    </FormSection>

    <FormSection>
      <FractionSelect
        v-model="order.fraction_uuid"
        :companyUuid="order.company_uuid"
        :disabled="!order.site_uuid || order.status != 'open'"
        :selectableInOrders="true"
        required
      />
      <VehicleSelect
        v-model="order.vehicle_uuid"
        :companyUuid="order.company_uuid"
        :disabled="!order.site_uuid || order.status != 'open'"
      />
    </FormSection>

    <WeightSection v-model="order" v-if="editMode" />

    <InfoSection v-model="order" v-if="editMode" />
  </div>
</template>

<script>
import InfoSection from '@/components/Orders/forms/sections/InfoSection.vue'
import WeightSection from '@/components/Orders/forms/sections/WeightSection.vue'
import ContainerSelect from '@/components/Orders/forms/sections/elements/ContainerSelect.vue'
import FractionSelect from '@/components/Orders/forms/sections/elements/FractionSelect.vue'
import SiteSelect from '@/components/Orders/forms/sections/elements/SiteSelect.vue'
import VehicleSelect from '@/components/Orders/forms/sections/elements/VehicleSelect.vue'
import ZoneSelect from '@/components/Orders/forms/sections/elements/ZoneSelect.vue'
import stringUtils from '@/components/mixins/stringUtils'

export default {
  name: 'PickupForm',
  components: {
    ContainerSelect,
    FractionSelect,
    InfoSection,
    SiteSelect,
    VehicleSelect,
    WeightSection,
    ZoneSelect,
  },
  mixins: [stringUtils],
  props: {
    value: { type: Object, required: false },
  },
  computed: {
    editMode() {
      return !!this.order.uuid
    },
    order: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit('input', value)
      },
    },
  },
}
</script>
